import classNames from "classnames"
import React from "react"

import Link from "@components/elements/Link"
import TextButton from "@components/elements/V2/Buttons/TextButton"
import GatsbyStoryblokImage from "@components/elements/V2/GatsbyStoryblokImage"
import ArrowIcon from "@components/elements/V2/Icons/ArrowIcon"
import Typography from "@components/elements/V2/Typography"
import { Color } from "@constants/V2/color"
import { getBackgroundColorClass } from "@utils/V2/color"
import { ContentHighlight } from "experiments/SaveAStep/NavHeading"

interface ContentHighlightCTAProps extends ContentHighlight {
  onClick?: () => void
}

const ContentHighlightCTA = ({
  title,
  description,
  ctaTitle,
  ctaDescription,
  ctaLink,
  ctaImage,
  ctaColor,
  onClick,
}: ContentHighlightCTAProps) => {
  return (
    <div className="col-span-4 pt-[6px] sm:pt-0">
      <Typography
        color={Color.Charcoal}
        font="grotesk"
        weight="book"
        size="subscript-sm"
        className="mb-16 hidden uppercase tracking-wide lg:block"
        text={title}
      />
      <Typography
        color={Color.Charcoal}
        font="grotesk"
        weight="book"
        size="subscript-sm-fixed"
        text={description}
        className="mb-24 hidden opacity-70 lg:block"
      />
      <div
        className={classNames(
          getBackgroundColorClass(ctaColor),
          "flex items-center gap-10 rounded-[7px] p-[6px]"
        )}
      >
        <GatsbyStoryblokImage
          image={ctaImage}
          alt={ctaTitle}
          aspectRatio="1:1"
          width={42}
          height={42}
          className="h-[42px] w-[42px] rounded-[4px]"
        />
        <Link link={ctaLink} className="flex h-full flex-col justify-center">
          <TextButton
            text={ctaTitle}
            style="icon"
            icon={<ArrowIcon width="12" height="10" />}
            color={Color.Black}
            textSize="body-md"
            onClick={onClick}
          />
          <Typography
            color={Color.Charcoal}
            font="grotesk"
            weight="book"
            size="subscript-sm-fixed"
            text={ctaDescription}
            className="opacity-70"
          />
        </Link>
      </div>
    </div>
  )
}

export default ContentHighlightCTA
